import { Form, styled } from 'core-ui';
interface StyledFormProps {
  isHiddenUploadSelect?: boolean;
}

const StyledForm = styled(Form)<StyledFormProps>`
  .ant-radio-group {
    flex-wrap: wrap;
  }
  .ant-radio-wrapper .ant-radio-checked {
    .ant-radio-inner {
      background: #fff;
      &::after {
        transform: scale(0.3635);
        width: 22px;
        height: 22px;
        margin-block-start: -11px;
        margin-inline-start: -11px;
        background-color: rgba(82, 114, 189);
      }
    }
  }
  .ant-radio-wrapper-disabled.ant-radio-wrapper
    .ant-radio-checked
    .ant-radio-inner {
    &::after {
      background-color: rgba(0, 0, 0, 0.25);
    }
  }

  .ant-form-item-label {
    font-weight: bold;
  }
  .ant-upload-list-picture-card {
    flex-wrap: nowrap !important;
    overflow-x: auto;
    position: relative;

    .ant-upload-list-item-container {
      .ant-upload-list-item {
        min-width: 102px;
      }
    }

    .ant-upload-select {
      position: sticky;
      right: 0;
      z-index: 100;
      background-color: #fff !important;
      .ant-upload {
        min-width: 102px;
      }
      ${({ isHiddenUploadSelect }) =>
        isHiddenUploadSelect &&
        `
        display: none;
      `}
    }
  }
`;
export default StyledForm;
